import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from 'react';
import { H2 } from '../../../components/typography';
import { useAPI } from '../../../hooks/useAPI';
import { useTranslation } from 'react-i18next';

const EmailConfirmationTwo = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const { BFRApplicationAcceptanceTwo, isLoading } = useAPI();
  const [isAccepted, setIsAccepted] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const applicationId = queryParameters.get('application-id');
    const isAcceptedParam = queryParameters.get('is-accepted');
    (async () => {
      await BFRApplicationAcceptanceTwo({
        applicationId,
        isAccepted: isAcceptedParam === 'true'
      });
    })();
    setIsAccepted(isAcceptedParam === 'true');
  }, [BFRApplicationAcceptanceTwo, queryParameters]);

  if (isLoading && isAccepted === null) {
    return (
      <Box>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <H2 fontWeight="bold">
        {t(
          isAccepted
            ? 'email_conf_2_title_accepted'
            : 'email_conf_2_title_denied'
        )}
      </H2>
    </Box>
  );
};

export default EmailConfirmationTwo;
